import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePublicOfferAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PublicOffer';
import { useGlobalProductContext } from '../../../../../contexts';

import { PublicOfferItemTypes } from '.';

export const PublicOfferItemMobile: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePublicOfferAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const middleInfos1 = [
    {
      label: 'Empresa',
      value: <UI.Text color="neutral.dark">{offer.companyName}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Nome',
      value: <UI.Text color="neutral.dark">{offer.offerName}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos2 = [
    {
      label: 'Cód. Isin',
      value: <UI.Text color="neutral.dark">{offer.isinCode}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Alteração',
      value: <UI.Text color="neutral.dark">{offer.alterationDateFormatted}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos3 = [
    {
      label: 'Negociação',
      value: <UI.Text color="neutral.dark">{offer.negotiationDateFormatted}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Liquidação',
      value: <UI.Text color="neutral.dark">{offer.liquidityDateFormatted}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos4 = [
    {
      label: 'Perfil',
      value: <UI.Text color="neutral.dark">{offer.suitabilityProfile}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Limitador',
      value: <UI.Text color="neutral.dark">{offer.rateLimiterTranslated}</UI.Text>,
      w: '49%',
    },
  ];

  const infos = [middleInfos1, middleInfos2, middleInfos3, middleInfos4];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack alignItems="center" space={Spacing['inline.quarck']}>
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
          <UI.Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.lg']}>
            {offer.offerType}
          </UI.Text>
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space={Spacing['stack.quarck']} key={label}>
                {!!label && (
                  <UI.Text color="neutral.black" variant="semibold">
                    {label}
                  </UI.Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
